var DocumentsNoticesSearch = function() {

		var comp = $('[data-page="documents-notices-search"]');

		this.init = function() {
			formValidate();
		}

	// Define os campos a serem validados
	function formValidate() {
		comp.find('#form-documents-notices-search').validate({
			rules: {
				noticeDateFrom: "required",
				noticeDateTo: "required",
				noticeCategory: "required",
				accountNumber: "required"
			}
		});
	}
	return this.init();
}
